module.exports = __webpack_public_path__ + "static/media/stomach.632a6cee.svg";